import Guard from '../../services/Middleware'

export default [
  {
    path: '/Lista-Veiculos',
    name:'Gestao de Veiculos',
    component: () => import('@/views/veiculos/index'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Adicionar',
    name:'Adicionar Veículos',
    component: () => import('@/views/veiculos/add.vue'),
    beforeEnter: Guard.auth,
  },
  {
    path: '/Veiculos/Adicionar/:id',
    name:'Editar Veículos',
    component: () => import('@/views/veiculos/add.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Detalhes/:id',
    name:'Detalhes Veículos',
    component: () => import('@/views/veiculos/detalhes.vue'),
    beforeEnter: Guard.auth,
  },
  {
    path: '/Veiculos/Manutecao',
    name:'Manutenção',
    component: () => import('@/views/veiculos/indexManutencao'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Manutecao/Adicionar',
    name:'Adicionar Manutenção',
    component: () => import('@/views/veiculos/addManutencao'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Manutecao/Editar/:id',
    name:'Editar Manutenção',
    component: () => import('@/views/veiculos/addManutencao'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Manutecao/Detalhes/:id',
    name:'Detalhes Manutenção',
    component: () => import('@/views/veiculos/detalhesManutencao'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Manutecao/:placa',
    name:'Detalhes Placa',
    component: () => import('@/views/veiculos/manutencaoPlaca'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/Multas',
    name:'Multas',
    component: () => import('@/views/veiculos/multas/index'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Veiculos/IPVA/:placa',
    name:'IPVA',
    component: () => import('@/views/veiculos/ipva'),
    beforeEnter: Guard.auth
  },
  
  
]
